import {StyleSheet} from 'react-native';
import {lightTheme, darkTheme} from '~constants/colors';
const createStyles = (colors: typeof lightTheme | typeof darkTheme) =>
  StyleSheet.create({
    flex: {
      flex: 1,
    },
    modal: {
      flex: 1,
      overflow: 'hidden',
      justifyContent: 'flex-end',
      margin: 0,
    },
    modalContent: {
      backgroundColor: colors.surface,
      borderTopWidth: 1,
      borderTopColor: colors.border,
    },
    slider: {
      alignSelf: 'center',
      width: 36,
      height: 5,
      backgroundColor: colors.gray400,
      borderRadius: 4,
      marginBottom: 8,
    },
    safeAreaContainer: {
      flex: 1,
      justifyContent: 'flex-end',
    },
    buttonText: {
      fontWeight: '500',
      color: colors.primary,
      fontSize: 17,
    },
  });

export default createStyles;
